import setHighestPriorityPackage from "./setHighestPriorityPackage";
import getAvailability from "./getAvailability";
import getPrice from "./getPrice";

const searchPrestationsForFilter = async (storeObj: any) => {
	const { state, commit, dispatch } = storeObj;
	if (state.productUnavailable) return;

	dispatch("setLoading", true);
	commit("setQuoteRequestsFinishedLoading", false);
	const avail_promise = getAvailability(
		storeObj.state.packCode,
		storeObj.state.dates.BeginDate,
		storeObj.state.dates.EndDate,
		storeObj
	);

	// fire price request asynchronously and not wait for it to finish
	if (state.packCode !== "HS") {
		new Promise(async (resolve) => {
			try {
				await getPrice(
					storeObj.state.packCode,
					storeObj.state.dates.BeginDate,
					storeObj.state.dates.EndDate,
					storeObj
				);
			} catch (err) {
				console.error(err);
			} finally {
				resolve(null);
			}
		});
	}

	const avail_resp = await avail_promise;
	dispatch("setLoading", false);

	// set more expensive package if package from url is not available
	const isPackageFromHashAvailable =
		!!avail_resp &&
		!!avail_resp.availablePackages?.find(
			(packObj: any) => packObj.codePackage === storeObj.state.packCode
		);
	if (
		avail_resp &&
		avail_resp.availablePackages &&
		!isPackageFromHashAvailable
	) {
		setHighestPriorityPackage(storeObj);
	}
};

export default searchPrestationsForFilter;
